__turbopack_context__.v({
  "input": "LoginForm-module__SJBfHG__input",
  "signInButton": "LoginForm-module__SJBfHG__signInButton",
});
